import React from "react";
import { motion } from "framer-motion";

const WhitePaperBanner = () => {
    return (
        <section className="w-full bg-[#030712] py-16 sm:py-20 lg:py-24 text-left relative z-10 font-sans overflow-hidden">
            <div className="absolute inset-0 w-full h-full pointer-events-none opacity-60">
                <img
                    src="/assets/analyst/img5.png"
                    alt="Futuristic server blocks matrix background"
                    className="w-full h-full object-cover object-center scale-100"
                    onError={(e) => {
                        e.target.style.display = 'none';
                    }}
                />
            </div>

            <div className="max-w-[1440px] mx-auto w-full relative z-20">
                <div className="flex flex-col items-start w-full">

                    <motion.div
                        initial={{ opacity: 0, scale: 0.97, y: 30 }}
                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        className="w-full sm:w-[500px] lg:w-[540px] bg-white p-6 sm:p-10 md:p-12 min-h-[280px] sm:min-h-[320px] flex flex-col justify-between items-start shadow-2xl shrink-0"
                    >
                        <div className="w-full flex flex-col gap-2">
                            <span className="text-[16px] sm:text-[20px] font-[600] font-sora text-[#ED6800] tracking-wide">
                                White Paper
                            </span>
                            <h2 className="text-[14px] md:text-[16px] font-[500] font-graphik text-[#01386A] leading-[1.25] tracking-tight break-words w-full">
                                Explore AI Agent Governance and Identity Security Guide
                            </h2>
                        </div>

                        <a
                            href="#download"
                            className="inline-flex items-center gap-2 text-[14px] sm:text-[16px] font-[500] font-graphik text-[#01386A] border-b-2 border-[#0F3661] pb-1 hover:text-[#ED6800] hover:border-[#ED6800] transition-colors duration-300 group outline-none select-none shrink-0"
                        >
                            <span>Download Now</span>
                            <span className="transition-transform duration-300 group-hover:translate-x-1.5 text-[16px]">&gt;</span>
                        </a>
                    </motion.div>

                </div>
            </div>
        </section>
    );
};

export default WhitePaperBanner;